import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/navigation/TokenDialog.js";
import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@material-ui/core';
import Util from "../../util/Util";
import Typography from "@material-ui/core/Typography";
class TokenDialog extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleClickOpen", () => {
      this.setState({
        open: true
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        open: false
      });
    });
    _defineProperty(this, "copyToClipboard", token => {
      const permissionsToRequest = {
        permissions: ["clipboard-write"]
      };
      navigator.permissions.query({
        name: "clipboard-write"
      }).then(result => {
        if (result.state === "granted" || result.state === "prompt") {
          /* write to the clipboard now */
          navigator.clipboard.writeText(token).then(function () {
            /* clipboard successfully set */
          }, function () {
            /* clipboard write failed */
          });
        } else {
          browser.permissions.request(permissionsToRequest).then(resp => {
            if (!resp) Util.openSnackbar('Unable to Copy Token To Clipboard: Request for clipboard-write permission was denied', this.parentSnackbarRef);
          });
        }
      });
    });
    this.state = {
      open: false,
      token: props.token != null ? props.token : null
    };
    this.parentSnackbarRef = null;
  }
  setToken(token) {
    this.state.token = token;
  }
  setParentSnackbarRef(parentSnackbarRef) {
    this.parentSnackbarRef = parentSnackbarRef;
  }
  render() {
    if (this.state.description === null) {
      return null;
    }
    const sampleCurl = "curl -s -H \"Authorization: Bearer ".concat(this.state.token, "\" \"YOUR_TPIS_HTTP_API_HERE\" | python -m json.tool");
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      open: this.state.open,
      onClose: this.handleClose,
      maxWidth: "md",
      fullWidth: true,
      scroll: 'paper',
      "aria-labelledby": "token-dialog-title",
      "aria-describedby": "token-dialog-description",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(DialogContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      justify: "center",
      alignContent: "center",
      alignItems: "center",
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      justify: "space-between",
      alignContent: "center",
      alignItems: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 37
      }
    }, "Your token:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.copyToClipboard(this.state.token);
        Util.openSnackbar('Copied token to clipboard', this.parentSnackbarRef);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 37
      }
    }, "Copy Token"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement("code", {
      style: {
        wordBreak: 'break-all'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 33
      }
    }, this.state.token)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      justify: "space-between",
      alignContent: "center",
      alignItems: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 37
      }
    }, "Sample API cURL command:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.copyToClipboard(sampleCurl);
        Util.openSnackbar('Copied sample cURL to clipboard', this.parentSnackbarRef);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 37
      }
    }, "Copy sample cURL"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement("code", {
      style: {
        wordBreak: 'break-all'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 33
      }
    }, sampleCurl)))), /*#__PURE__*/React.createElement(DialogActions, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.handleClose();
      },
      color: "primary",
      autoFocus: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 25
      }
    }, "Close"))));
  }
}
export default TokenDialog;